import {
    Component,
    forwardRef,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SpecRowDto } from 'app/shared/apis/product/model/specRowDto';

// SESSION-admin-ptg-002 — shared key-specs editor (`.spec-edit-row` + `Add spec`).
// CVA over SpecRowDto[]. Specs are unordered — no renumbering. Reused by the
// Add-product + Edit-info modals (session 003).
@Component({
    selector: 'app-spec-row-repeater',
    templateUrl: './spec-row-repeater.component.html',
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SpecRowRepeaterComponent),
            multi: true,
        },
    ],
})
export class SpecRowRepeaterComponent implements ControlValueAccessor {
    @Input() labelPlaceholder = 'Label';
    @Input() valuePlaceholder = 'Value';

    rows: SpecRowDto[] = [];

    private onChange: (v: SpecRowDto[]) => void = () => {};
    private onTouched: () => void = () => {};

    writeValue(v: SpecRowDto[]): void {
        this.rows = Array.isArray(v) ? v.map((r) => ({ ...r })) : [];
    }
    registerOnChange(fn: (v: SpecRowDto[]) => void): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    addRow(): void {
        this.rows = [...this.rows, { label: '', value: '' }];
        this.emit();
    }

    removeRow(index: number): void {
        this.rows.splice(index, 1);
        this.rows = [...this.rows];
        this.emit();
    }

    updateLabel(index: number, label: string): void {
        this.rows[index].label = label;
        this.emit();
    }

    updateValue(index: number, value: string): void {
        this.rows[index].value = value;
        this.emit();
    }

    trackByIndex(index: number): number {
        return index;
    }

    private emit(): void {
        this.onChange(this.rows);
        this.onTouched();
    }
}
